import { VerticalType } from '../../types/cmsTypes';
import { MaterialIconName } from '../../types/materialIconName';
import { TranslationKey } from './i18n';

export const TITLE_SECTION_DETAIL_MAP: Partial<
  Record<VerticalType, TranslationKey>
> = {
  PERSONAL_LOANS: 'loan_details',
  CREDIT_CARD: 'card_details',
  BANKING: 'stk_bka_product_details',
  INVESTMENTS: 'stk_bka_product_details',
  INSURANCE: 'stk_bka_product_details',
  TRAVEL_INSURANCE: 'card_details_ti_ci',
  CAR_INSURANCE: 'card_details_ti_ci',
};

export const ICON_SECTION_DETAIL_MAP: Partial<
  Record<VerticalType, MaterialIconName>
> = {
  CREDIT_CARD: 'credit_card',
  BANKING: 'shield_with_heart',
  INVESTMENTS: 'shield_with_heart',
  INSURANCE: 'shield_with_heart',
  TRAVEL_INSURANCE: 'credit_card',
  CAR_INSURANCE: 'credit_card',
};

export type PrefixCurrencyType = 'HK$' | 'S$' | 'NT$' | '₱';
export const prefixCurrency: PrefixCurrencyType[] = ['HK$', 'S$', 'NT$', '₱'];
export const isPrefixCurrency = (value: string | undefined): boolean =>
  !!value && prefixCurrency.includes(value as PrefixCurrencyType);

export const coverageAttributesList = [
  'BATTERY_BOOSTING',
  'ACCESS_TO_CRITICAL_INFORMATION',
  'JUMPSTART',
  'FLAT_TIRE_REPLACEMENT',
  'DELIVERY_OF_GASOLINE',
];

export const allowedTIVerticals: Array<VerticalType> = [
  'CREDIT_CARD',
  'PERSONAL_LOANS',
  'BANKING',
  'TRAVEL_INSURANCE',
  'CAR_INSURANCE',
  'INVESTMENTS',
];
